import { render, staticRenderFns } from "./ChooseBusinessType.vue?vue&type=template&id=1831683c&"
import script from "./ChooseBusinessType.vue?vue&type=script&lang=js&"
export * from "./ChooseBusinessType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports